export default "__VITE_ASSET__8f1c4cc2__"